export enum NewsletterOverlayType {
  ADDITIONAL_FIELDS = 'ADDITIONAL_FIELDS',
  STANDARD = 'STANDARD',
}

export const scrollThreshold = 500
